import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NAVBAR } from "../../constants/ui";
import useTailwindBreakpoint from "../../hooks/useTailwindBreakpoint";
export default function NavbarContext({ children, className }) {
    const isLg = useTailwindBreakpoint("lg");
    return (_jsxs("div", { className: className, children: [_jsx("div", { className: `${isLg ? NAVBAR.HEIGHT.DESKTOP : NAVBAR.HEIGHT.MOBILE} w-full shrink-0` }), children] }));
}
